<template>
  <div>
    <navbar-top left="back"
                middle="title"
                @cl="back">
      <p class="text-2xl text-white font-semibold">Видео</p>
    </navbar-top>

    <div class="fixed inset-0 pt-14 bg-blue-850 overflow-y-auto">
      <div v-if="dataLoaded"
           class="wrapper">
        <div class="flex flex-col p-6">
          <template v-if="hasError">
            <h1 class="text-2xl text-white font-bold">Такого видео нет :(</h1>
            <p class="mt-1 text-white">Проверь ссылку: возможно, в ней есть опечатка. Если ошибка продолжает повторяться, напиши Георгию.</p>
          </template>

          <template v-else>
            <VideoViewer :source="video.source" :link="link" />

            <h1 class="mt-2 text-xl leading-tight text-white font-bold sm:text-2xl">{{ video.title }}</h1>
            <ol class="mt-4">
              <li v-for="chapter in video.chapters"
                 :key="chapter.start"
                 class="grid justify-start gap-3 text-white"
              style="grid-template-columns: 4.5rem 1fr;">
                <p>{{hhmmss(chapter.start)}}</p>
                <p>{{ chapter.title }}</p>
              </li>
            </ol>
          </template>
        </div>
      </div>
      <menu-spinner v-else></menu-spinner>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import NavbarTop from '@/components/NavbarTop';
import MenuSpinner from '@/components/MenuSpinner.vue';
import VideoViewer from "@/components/VideoViewer.vue";

export default {
  components: { VideoViewer, NavbarTop, MenuSpinner },
  props: { videoAlias: String },
  data () {
    return {
      dataLoaded: false,
      hasError: false,
    };
  },
  computed: {
    ...mapState({
      video: state => state.video.video,
    }),
    link () {
      if (this.hasError || !this.video) return '';

      if (this.video.source === 'bunny') {
        return `https://iframe.mediadelivery.net/embed/${this.video.libraryId}/${this.video.videoId}?token=${this.video.hash}&expires=${this.video.exp}&preload=true`;
      } else if (this.video.source === 'kinescope') {
        return `https://kinescope.io/embed/${this.video.videoId}`;
      }

      return '';
    },
  },
  created () {
    this.$store.dispatch('video/fetchVideo', this.videoAlias)
      .then(() => this.dataLoaded = true)
      .catch(() => {
        this.hasError = true;
        this.dataLoaded = true;
      });
  },
  methods: {
    hhmmss (seconds) {
      const h = Math.floor(seconds / 3600).toFixed().padStart(2, '0');
      const m = Math.floor((seconds % 3600) / 60).toFixed().padStart(2, '0');
      const s = (seconds % 60).toFixed().padStart(2, '0');
      return `${h}:${m}:${s}`;
    },
    back () { this.$router.push('/'); },
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  display: block;
  margin: auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  @media (max-width: 639px) {
    width: 100%;
  }

  @media (min-width: 640px) {
    width: 75%;
  }

  @media (min-width: 1024px) {
    width: 50%;
  }
}
</style>
